<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div v-if="product" class="modal-dialog" role="document">
			<div class="modal-content">
				<loading :active="loading">
					<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
				</loading>
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4>Editar alerta</h4>
				</div>
				<div v-if="item" class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div class="form-group" :class="{ 'has-error' : errors.has('product_alert_type_id') }">
								<label class="control-label">Tipo</label>
								<select
									v-validate="'required'"
									name="product_alert_type_id"
									data-vv-as="Tipo de alerta"
									v-model="item.product_alert_type_id"
									class="form-control">
									<template v-if="types">
										<template v-if="types.length">
											<option v-for="type in types" :value="type.id">
												<template v-if="type.lang">
													{{ type.lang.name }}
												</template>
												<template v-else>
													{{ type.name }}
												</template>
											</option>
										</template>
									</template>
								</select>
								<small v-show="errors.has('product_alert_type_id')" class="form-text text-danger">
									{{ errors.first('product_alert_type_id') }}
								</small>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-12">
							<div class="form-group" :class="{ 'has-error' : errors.has('name') }">
								<label class="control-label">Nombre</label>
								<input
									v-validate="'required'"
									v-model="item.name"
									type="text"
									data-vv-as="Nombre"
									name="name"
									class="form-control">
								<small v-show="errors.has('name')" class="form-text text-danger">
									{{ errors.first('name') }}
								</small>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label class="control-label">Mínimo</label>
								<input
									v-model="item.min"
									type="number"
									class="form-control">
							</div>
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label class="control-label">Máximo</label>
								<input
									v-model="item.max"
									type="number"
									class="form-control">
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button ref="btnStore" @click="validate()" type="button" class="btn btn-success">Guardar</button>
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['user', 'isAuth', 'product'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-product-alerts-edit',
				},
				loading: false,
				types: null,
				item: null,
			}
		},
		watch: {
			'item.min'() {
				this.item.min = this.$options.filters.checkDecimals(this.item.min)
			},
			'item.max'() {
				this.item.max = this.$options.filters.checkDecimals(this.item.max)
			}
		},
		methods: {
			open(item) {
				this.item = null
				if(item) {
					this.item = JSON.parse(JSON.stringify(item))
				}
				this.clearData()
				this.getTypes()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			getTypes() {
				this.loading = true
				this.$http.get('admin/management/products/alert/types')
				.then(response => {
					this.loading = false
					this.types = response.body
				})
			},
			clearData() {
				this.errors.clear()
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.update()
					}
					return result
				})
			},
			update() {
				this.loading = true
				this.$http.put('admin/management/products/alerts/' + this.item.id, this.item)
					.then(response => {
						this.loading = false
						this.close()
						this.$emit('reload')
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					}).catch(function(response) {
						console.log(response)
						this.loading = false
					})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/products/components/alerts/views/Edit.vue